interface TileAttribution {
  matches: string[];
  text: string;
}

const tileAttributions: TileAttribution[] = [
  {
    matches: ["cartodb", "cartocdn"],
    text: "© <a href='http://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> contributors, © <a href='https://carto.com/attribution' target='_blank'>CARTO</a>",
  },
  {
    matches: ["opentopomap.org"],
    text: "© <a href='http://www.openstreetmap.org/copyright' target='_blank'>OpenStreetMap</a> contributors",
  },
  {
    matches: ["arcgisonline.com"],
    text: "Powered by <a href='https://developers.arcgis.com/terms/attribution/' target='_blank'>Esri</a>",
  },
  {
    matches: ["/watercolor/"],
    text: "Map tiles by <a href='http://stamen.com' target='_blank'>Stamen Design</a>, under <a href='http://creativecommons.org/licenses/by/3.0' target='_blank'>CC BY 3.0</a>. Data by <a href='http://openstreetmap.org' target='_blank'>OpenStreetMap</a>, under <a href='http://www.openstreetmap.org/copyright' target='_blank'>ODbL</a>.",
  },
  {
    matches: ["stamen-tiles", "stamen.com"],
    text: "Map tiles by <a href='http://stamen.com' target='_blank'>Stamen Design</a>, under <a href='http://creativecommons.org/licenses/by/3.0' target='_blank'>CC BY 3.0</a>. Data by <a href='http://openstreetmap.org' target='_blank'>OpenStreetMap</a>, under <a href='http://creativecommons.org/licenses/by-sa/3.0' target='_blank'>CC BY SA</a>.",
  },
];

export default tileAttributions;
